module.exports = __webpack_public_path__ + "static/media/sc3.99874916.mp4";